// extracted by mini-css-extract-plugin
export var deleteModal = "_kw-0";